export default __webpack_public_path__ + "static/media/B18.9979789e.png";